module.exports = __webpack_public_path__ + "media/images/icons/vendors/marriageregistration-cdb8bb8e11c2bb394fc16b198f59ba92.png";